import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import ConstruirMinuta from './ConstruirMinuta';
import mergePdfs from './mergePdfs';

async function getCompressedJpg(dataUrl, quality = 0.8, maxWidth = 1000) {
    return new Promise((resolve) => {
        const img = new window.Image();
        img.onload = () => {
            // Redimensionar si es necesario
            let width = img.width;
            let height = img.height;
            if (width > maxWidth) {
                height = Math.round((maxWidth / width) * height);
                width = maxWidth;
            }
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);
            resolve(canvas.toDataURL('image/jpeg', quality));
        };
        img.src = dataUrl;
    });
}

const ConstruirPdfAyudaHumanitariaFirma = async (datos, Encabezado, Titulos, images, userNombre, usrIdPersona, infoMinuta) => {
    const pdf = new jsPDF('p', 'pt', [600, 500], { compress: true });
    pdf.setFontSize(7).setFont("helvetica", 'normal');
    pdf.text("??", 10,20,);
    const firmaPersona = images?.sigCanvas;
    if(datos){
        const img = new Image()
        img.src = '/dist/img/alcaldialogo.jpg';
        pdf.addImage(img, 'png', 400, 30, 70, 40);
        pdf.setFontSize(9).setFont("helvetica", 'bold')
        const titulo1 = Titulos.find(titulo => titulo.camNombrecampo === "titulo1").camValorcampo;
        const pageWidth = pdf.internal.pageSize.getWidth();
        const textWidth = pdf.getTextWidth(titulo1);
        const textX = (pageWidth - textWidth) / 2;
        pdf.text(titulo1, textX, 80);
        pdf.setFontSize(9).setFont("helvetica", 'bold')
        pdf.text(Titulos.find(titulo => titulo.camNombrecampo === "titulo2").camValorcampo, 200,100,);
        pdf.setFontSize(8).setFont("helvetica", 'normal')
        pdf.text(Titulos.find(titulo => titulo.camNombrecampo === "fecha").camValorcampo, 25,140,);
        pdf.setFontSize(8).setFont("helvetica", 'bold')
        pdf.text(Encabezado.fecha.split('T')[0], 70,140,);
        pdf.setFontSize(8).setFont("helvetica", 'normal')
        pdf.text(Titulos.find(titulo => titulo.camNombrecampo === "documento").camValorcampo, 150,140);
        pdf.setFontSize(8).setFont("helvetica", 'bold')
        pdf.text(Encabezado.idpersona, 270,140,);
        pdf.setFontSize(8).setFont("helvetica", 'normal')
        pdf.text(Titulos.find(titulo => titulo.camNombrecampo === "nombre").camValorcampo, 25,152);
        pdf.setFontSize(8).setFont("helvetica", 'bold')
        pdf.text(Encabezado.nombre, 150,152);
        pdf.setFontSize(8).setFont("helvetica", 'normal')
        const componente = Titulos.find(titulo => titulo.camNombrecampo === "componente").camValorcampo;
        const componentenombre = Titulos.find(titulo => titulo.camNombrecampo === "componentenombre").camValorcampo;
        pdf.text(`${componente}: ${componentenombre}`, 25,170);
        pdf.setFontSize(8).setFont("helvetica", 'normal')
        pdf.text(Titulos.find(titulo => titulo.camNombrecampo === "entrega").camValorcampo, 25,182,);
        pdf.setFontSize(8).setFont("helvetica", 'bold')
        pdf.text(Encabezado.entrega, 90,182);
        pdf.setFontSize(8).setFont("helvetica", 'normal')
        pdf.text(Titulos.find(titulo => titulo.camNombrecampo === "textocontratos").camValorcampo, 25,205, {maxWidth: 420, align: 'justify'});
        const data = [["","","",""]];
        const Total = 0;
        for (const element of datos) {
            data.push([element.cantidad.toString(), element.ayuda, `$ ${element.valor.toString()}`, `$ ${element.valor.toString()}`]);
        }
        data.splice(0, 1);

        const RowsCount = data.length;
        let PositionTables = 240;

        autoTable(pdf, {
            startY: PositionTables,
            margin: { left: 25, bottom: 25 },
            tableLineColor: [0, 0, 0],
            tableLineWidth: 0.75,
            theme: "plain",
            headStyles: {
            halign: 'center',
            fillColor: [255, 255, 255],
            lineColor: [0,0,0],
            textColor: [0, 0, 0],
            lineWidth: 0.5,
            fontSize: 8,
            cellPadding: 1
            },
            columnStyles: {
            0: { halign: 'center', cellWidth: 70, lineWidth: 0.5, lineColor: [0, 0, 0], fontSize: 8, cellPadding: 1},
            1: { halign: 'left', cellWidth: 205, lineWidth: 0.5, lineColor: [0, 0, 0], fontSize: 8, cellPadding: 1},
            2: { halign: 'right', cellWidth: 80, lineWidth: 0.5, lineColor: [0, 0, 0], fontSize: 8, cellPadding: 1},
            3: { halign: 'right', cellWidth: 80, lineWidth: 0.5, lineColor: [0, 0, 0], fontSize: 8, cellPadding: 1}
            },
            head: [['Cantidad', 'Descripción', 'Valor unitario', 'Valor']],
            body: data,
        });
        PositionTables = PositionTables + ((RowsCount+1)*11.1);
        const dataTotal = [["Total: ", `$ ${Encabezado.valor.toString()}`]];
        autoTable(pdf, {
            startY: PositionTables,
            margin: { left: 25, bottom: 25 },
            tableLineColor: [0, 0, 0],
            tableLineWidth: 0.75,
            theme: "plain",
            columnStyles: {
            0: { halign: 'right', cellWidth: 355, lineWidth: 0.5, lineColor: [0, 0, 0], fontSize: 8, cellPadding: 1},
            1: { halign: 'right', cellWidth: 80, lineWidth: 0.5, lineColor: [0, 0, 0], fontSize: 8, cellPadding: 1}
            },
            body: dataTotal,
        });
        PositionTables = PositionTables + 50;
        pdf.setFontSize(8).setFont("helvetica", 'normal')
        pdf.text("RECIBE ", 25,PositionTables);
        PositionTables = PositionTables + 5;
        let dataFirma = [[`C.C. Nro. ${datos[0].idpersona??''}`,"Huella índice derecho"]];
        autoTable(pdf, {
            startY: PositionTables,
            tableWidth: 270,
            margin: { left: 25, bottom: 25 },
            tableLineColor: [0, 0, 0],
            tableLineWidth: 0.75,
            theme: "plain",
            columnStyles: {
            0: { valign: 'bottom', halign: 'left', cellWidth: 210, minCellHeight: 50, lineWidth: 0.5, lineColor: [0, 0, 0], fontSize: 8, cellPadding: 1},
            1: { valign: 'bottom', halign: 'center', cellWidth: 60, minCellHeight: 50, lineWidth: 0.5, lineColor: [0, 0, 0], fontSize: 5, cellPadding: 1}
            },
            body: dataFirma,
        });
        if (firmaPersona) {
            pdf.addImage(firmaPersona, 'PNG', 40, PositionTables + 5, 150, 35);
        }
        PositionTables = PositionTables + 80;
        pdf.setFontSize(8).setFont("helvetica", 'normal')
        pdf.text("ENTREGA ", 25,PositionTables);
        PositionTables = PositionTables + 5;
        dataFirma = [[`C.C. Nro. ${usrIdPersona??''}`]];
        autoTable(pdf, {
            startY: PositionTables,
            tableWidth: 270,
            margin: { left: 25, bottom: 25 },
            tableLineColor: [0, 0, 0],
            tableLineWidth: 0.75,
            theme: "plain",
            columnStyles: {
            0: { valign: 'bottom', halign: 'left', cellWidth: 270, minCellHeight: 40, lineWidth: 0.5, lineColor: [0, 0, 0], fontSize: 8, cellPadding: 1}

            },
            body: dataFirma,
        });
        if (images?.sigCanvasEntrega) {
            pdf.addImage(images.sigCanvasEntrega, 'PNG', 40, PositionTables + 5, 150, 35);
        }
        PositionTables = PositionTables + 40;
        dataFirma = [["Nombre", userNombre ]];
        autoTable(pdf, {
            startY: PositionTables,
            tableWidth: 270,
            margin: { left: 25, bottom: 25 },
            tableLineColor: [0, 0, 0],
            tableLineWidth: 0.75,
            theme: "plain",
            columnStyles: {
            0: { valign: 'bottom', halign: 'left', cellWidth: 60, lineWidth: 0.5, lineColor: [0, 0, 0], fontSize: 8, cellPadding: 1},
            1: { valign: 'bottom', halign: 'center', cellWidth: 210, lineWidth: 0.5, lineColor: [0, 0, 0], fontSize: 5, cellPadding: 1}
            },
            body: dataFirma,
        });
        PositionTables = PositionTables + 22;
        pdf.setFontSize(8).setFont("helvetica", 'normal')
        pdf.text(Titulos.find(titulo => titulo.camNombrecampo === "operador").camValorcampo, 25,PositionTables);
        const pageHeight = pdf.internal.pageSize.getHeight();
        if (images?.imageCedulaLadoA && images?.imageCedulaLadoB) {
            pdf.addPage();
            const imgWidth = pageWidth - 80; // 40 margin each side
            const imgHeight = (pageHeight - 100) / 2; // half page, minus margins
            // Top half
            pdf.addImage(images.imageCedulaLadoA, 'JPG', 40, 40, imgWidth, imgHeight);
            // Bottom half
            pdf.addImage(images.imageCedulaLadoB, 'JPG', 40, 60 + imgHeight, imgWidth, imgHeight);
        } else if (images?.imageCedulaLadoA && !images?.imageCedulaLadoB) {
            pdf.addPage();
            const jpgCedulaA = await getCompressedJpg(images.imageCedulaLadoA, 0.8, 1000);
            pdf.addImage(jpgCedulaA, 'JPEG', 40, 40, 400, 400);
        } else if (!images?.imageCedulaLadoA && images?.imageCedulaLadoB) {
            pdf.addPage();
            const jpgCedulaB = await getCompressedJpg(images.imageCedulaLadoB, 0.8, 1000);
            pdf.addImage(jpgCedulaB, 'JPEG', 40, 40, 400, 400);
        }
        if (images?.imageEvidenciaEntrega) {
            pdf.addPage();
            const jpgEvidencia = await getCompressedJpg(images.imageEvidenciaEntrega, 0.8, 1000);
            pdf.addImage(jpgEvidencia, 'JPEG', 40, 40, 400, 400);
        }
        if (images?.imageEvidenciaEntregaComprobante) {
            pdf.addPage();
            const jpgComprobante = await getCompressedJpg(images.imageEvidenciaEntregaComprobante, 0.8, 1000);
            pdf.addImage(jpgComprobante, 'JPEG', 40, 40, 400, 400);
        }
    }
    const pdfBlob  = pdf.output('blob');
    const fileURL = URL.createObjectURL(pdfBlob);
    const datosMinuta = datos.filter(d => d.ayuda?.includes("Alimento") || d.ayuda?.includes("Kits") || d.ayuda?.includes("Kit"));
    const tieneAlimentos = datosMinuta.length > 0;
    let fileURLMinuta = null;
    if(tieneAlimentos){
        fileURLMinuta = await ConstruirMinuta({datosMinuta}, firmaPersona, infoMinuta);
        const mergedPdfUrl = await mergePdfs(fileURL, fileURLMinuta);
        return mergedPdfUrl;
    }
    return fileURL;
};

export default ConstruirPdfAyudaHumanitariaFirma;